// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__PZmdS","text":"ErrorBoundary_text__GMYPI"};